import React from "react";

import duoSleep from "../images/duo-sleep.svg";
import styles from "../styles/NoAvailableChallengesPage.module.scss";

const NoAvailableChallengesPage = () => (
  <div className={styles.container}>
    <img className={styles["duo-image"]} src={duoSleep} />
    <div>
      No available challenges for now. Please post in{" "}
      <a
        href="https://duolingo.slack.com/archives/CSQLHL05V"
        rel="noreferrer"
        target="_blank"
      >
        #learning-challenge
      </a>{" "}
      on Slack if you need help!
    </div>
  </div>
);

export default NoAvailableChallengesPage;
